import React from "react"
import { Grid, Typography, Paper } from "@mui/material"

import Main from "../components/Main"

const faqs = [
  {
    question: "Die E-Mail mit dem Registrierungscode bleibt aus. An wen wende ich mich?",
    answer: (
      <>
        Prüfe zunächst deinen Spam-Ordner. Falls die E-Mail auch dort nicht zu finden ist, schreibe von deinem{" "}
        <b>Schulemailaccount (@166364.schulen-bn.de)</b> aus eine kurze Mail an <b>dmitrij.tjumenzew@bookay-buecher.de</b>, um manuell freigeschaltet
        zu werden.
      </>
    ),
  },
  {
    question: "Was mache ich, wenn ich mich nicht mehr bei meinem Schulemailaccount (@166364.schulen-bn.de) anmelden kann?",
    answer: <>Wenn du dein Passwort vergessen hast, kannst du dein Passwort auf der Login-Seite zurücksetzen.</>,
  },
  {
    question: "Ich kann mein gekauftes / verkauftes Buch nicht auswählen oder finden. Was soll ich tun?",
    answer: (
      <>
        Wenn du einen Partner für das Buch gefunden hast, das Buch aber nicht mehr in der App zu finden ist, kann es sein, dass dein Partner den Kauf
        abgebrochen hat. Darüber wirst du in einer automatischen Mail informiert.
      </>
    ),
  },
  {
    question: "Weitere Fragen?",
    answer: <>Falls deine Frage hier nicht beantwortet wird, kontaktiere bitte unseren Support unter dmitrij.tjumenzew@bookay-buecher.de</>,
  },
]

const posts = [
  <Paper
    key="faq"
    elevation={0}
    sx={{
      my: 2,
      p: 2,
      bgcolor: "grey.200",
    }}>
    {faqs.map((faq, index) => (
      <Paper
        key={index}
        elevation={1}
        sx={{
          p: 2,
          mb: 2,
        }}>
        <Typography variant="body1" gutterBottom fontWeight="bold">
          {faq.question}
        </Typography>
        <Typography variant="body1">{faq.answer}</Typography>
      </Paper>
    ))}
  </Paper>,
]

const FAQ = () => {
  return (
    <>
      <Grid container spacing={5} sx={{ mt: 1 }}>
        <Main title="FAQ" posts={posts} fullSize />
      </Grid>
    </>
  )
}

export default FAQ
